import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import Icon from "../common/icons";
import UpdatesSheet from "./UpdatesSheet";
import { announceAccountLinked } from "./AccountLinkedNote";
import { useUpdatesState } from "./updatesStore";
import "./studentUpdates.css";

/**
 * The bell in the student header (StudentNav's AccountMenu puts it beside the account
 * button): a red count when something changed, and the Updates sheet on tap.
 * Students only; staff have their own bell in the guidance workspace.
 */
function Bell({ who }) {
  const { unread } = useUpdatesState(who);
  const [open, setOpen] = useState(false);
  // Once per sign-in (the bell mounts when a student is signed in): "Your account is now linked…" (C6)
  // Only looked up when something is unread, and once per page load (announceAccountLinked)
  const hasUnread = unread > 0;
  useEffect(() => { if (hasUnread) announceAccountLinked(who); }, [who, hasUnread]);
  const label = unread ? `Updates, ${unread} new` : "Updates";

  return (
    <>
      <button
        type="button"
        className={`ud-bell${unread ? " has-new" : ""}`}
        aria-label={label}
        title="Updates"
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <Icon name="bell" size={22} />
        {unread > 0 && (
          <span className="ud-count" key={unread} aria-hidden="true">{unread > 9 ? "9+" : unread}</span>
        )}
      </button>
      <UpdatesSheet show={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default function UpdatesBell() {
  const { isAuthenticated, user } = useContext(UserContext) || {};
  if (!isAuthenticated || !user || user.is_staff || user.is_superuser) return null;
  return <Bell who={user.id ?? user.email ?? "student"} />;
}
